import { Box, Button, Center, Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react'

import { getExploreUrl } from '@/client/services/url'
import { getArticleUrl } from '@/client/services/url/faq'

import SignUpLink from '@/components/Auth/SignUpLink'
import PublicImage from '@/components/PublicImage/PublicImage'
import ShwLink from '@/components/ShwLink'

import { STARS_GUIDED_RESOURCES_URL } from './constants'

const PARTICIPATE_STEPS = [
  {
    key: 'participate-step-1',
    name: () => (
      <Heading size="lg" as="h4" mb="16px">
        Create your Schoolhouse account
      </Heading>
    ),
    description: () => (
      <Box>
        <Text>
          Create a Schoolhouse account and check out all the tutoring we have to offer, from
          Pre-Algebra to Calculus through both 1:1 live help and small-group sessions. Everything is
          completely free!
        </Text>
        <Box mt={4}>
          <SignUpLink href={getExploreUrl()}>
            <Button variant="outline">Get Started</Button>
          </SignUpLink>
        </Box>
      </Box>
    ),
  },
  {
    key: 'participate-step-2',
    name: () => (
      <Heading size="lg" as="h4" mb="16px">
        Use our Guided Resources Document to learn on Schoolhouse and Khan Academy
      </Heading>
    ),
    description: () => (
      <Box>
        <Text>
          Use this document on how to best use Khan Academy to build math skills and Schoolhouse to
          receive extra tutoring support and certify what you’ve learned.
        </Text>
        <ShwLink href={STARS_GUIDED_RESOURCES_URL} mt={4}>
          <Button variant="outline">Check It Out</Button>
        </ShwLink>
      </Box>
    ),
  },
  {
    key: 'participate-step-3',
    name: () => (
      <Heading size="lg" as="h4" mb="16px">
        Submit your Schoolhouse portfolio in college applications
      </Heading>
    ),
    description: () => (
      <Box>
        <Text>
          All the learning and tutoring you do on Schoolhouse will be tracked in your Schoolhouse
          portfolio, which all STARS network schools accept in their college applications!
        </Text>
        <ShwLink href={getArticleUrl('what-is-a-portfolio')} mt={4}>
          <Button variant="outline">Learn More</Button>
        </ShwLink>
      </Box>
    ),
  },
]

export default function STARSHowToParticipate(): React.ReactElement {
  return (
    <SimpleGrid columns={[1, 1, 2]} spacing="54px" alignItems="center" my="36px">
      <Box>
        <Center>
          <PublicImage src="/home/Hero-v3.svg" width="100%" maxWidth="700px" margin="auto" />
        </Center>
      </Box>
      <Box>
        <Stack direction="column" spacing={['24px', '32px']} px="16px">
          <Heading size="2xl">How to Participate</Heading>
          {PARTICIPATE_STEPS.map(({ key, name, description }, index) => (
            <Stack key={key} direction="row" spacing={4} align="left">
              <Heading fontSize="48px" minWidth="32px" color="fg.subtle" fontWeight={900} flex={1}>
                {index + 1}
              </Heading>
              <Box>
                {name()}
                {description()}
              </Box>
            </Stack>
          ))}
        </Stack>
      </Box>
    </SimpleGrid>
  )
}
